angular.module('lead.activity' )
    .component('lastActivity', {
        bindings: {
            leadId: '<'
        },
        templateUrl: 'app/lead/lead-activities/last.html',
        controller: function ($scope, LeadActivity) {
            this.$onInit = () => {
                return LeadActivity.last({leadId: this.leadId}).$promise.then(activity => this.activity = activity);
            }
        }
    })
